import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Filter: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.17a3 3 0 0 1-.88 2.12L16 12.41V19a1 1 0 0 1-.68.95l-6 2a1 1 0 0 1-1.27-.63A1.19 1.19 0 0 1 8 21v-8.11L3.78 8.24a3 3 0 0 1-.78-2Zm2 1v1.23a1 1 0 0 0 .26.67l4.48 4.93a1 1 0 0 1 .26.67v7.11l4-1.33V12a1 1 0 0 1 .29-.71l4.42-4.41a1 1 0 0 0 .29-.71V5Z" />
  </Icon>
);

export default Filter;
